/***
 * @file: æ®éè¡¨æ ¼ææ½æä»¤
 * @Date: 2021-08-02 10:23:20
 * @author: linkun.he
 */
import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[normalTableResizable]',
})
export class TableResizableDirective implements AfterViewInit {
  // Headä¸­çcolåè¡¨
  colListOfHead: HTMLCollection | any;
  // Headä¸­çthåè¡¨
  thListOfHead: HTMLTableHeaderCellElement[];
  // Bodyä¸­çtråè¡¨
  trListOfBody: HTMLCollectionOf<HTMLTableRowElement> | any;
  // bodyä¸­çcolåè¡¨ï¼å headåbodyæ¯ç±ä¸¤ä¸ªè¡¨æ ¼å®ç°ï¼
  colListOfBody: HTMLCollection;
  // å½åæ¿æ´»åçindex
  activeIdx: number;
  // é¼ æ æä¸äºä»¶çå¬
  mousedown$: Subscription;
  // é¼ æ ç§»å¨äºä»¶çå¬
  mousemove$: Subscription;
  // é¼ æ æ¾å¼äºä»¶çå¬
  mouseup$: Subscription;
  // é¼ æ ç§»å¨çå¬äºä»¶æ°ç»ï¼é²æ­¢ç±äºç¹æ®åå ä¸è½å¸è½½ï¼æå¨ä¸ä¸ªæ°ç»ä¸­è®°å½ï¼å¾ªç¯å¸è½½ï¼
  mousemoveSubList: Subscription[] = [];

  // æå°å¯æå¨å¤§å°ï¼pxï¼
  @Input() minResizeWidth = 50;

  constructor(private $element: ElementRef<HTMLTableElement>) {}

  /**
   * é¡µé¢æ¸²æå®æï¼è·åè¡¨æ ¼åç´ 
   */
  ngAfterViewInit() {
    setTimeout(() => {
      this.getTableElements();
    }, 1000);
  }

  /**
   * è·åè¡¨æ ¼åç´ åèç¹
   */
  getTableElements() {
    const tableRefs: NodeListOf<HTMLTableElement> = this.getTableRefs();
    // head col list
    this.colListOfHead = tableRefs[0].children[0].children;
    // head tr
    const trOfhead: HTMLTableRowElement = tableRefs[0].tHead.rows[0];
    // head th list
    this.thListOfHead = Array.from(trOfhead.cells) as HTMLTableHeaderCellElement[];

    if (!tableRefs[1]) {
      throw new TypeError(
        "Please set `nzScroll` attr for `normalTableResizable` directive. Just like `nzScroll = { x: '500px', y: '600px' }`"
      );
    }
    // body col list
    this.colListOfBody = tableRefs[1].children[0].children;
    // body tr list
    this.trListOfBody = tableRefs[1].tBodies[0].rows;
    if (!this.colListOfHead) {
      throw new TypeError('Must have at least one TR element inside THEAD element');
    }
    // å¨head æ¯åé½å å¥iconï¼æ·»å mouseDownäºä»¶
    for (let i = 0; i < this.thListOfHead.length; i++) {
      this.insertIcon(i);
    }
  }

  /**
   * è·åè¡¨æ ¼çå¼ç¨
   * @return [headTableRef, bodyTableRef]
   */
  getTableRefs(): NodeListOf<HTMLTableElement> {
    const ele: HTMLTableElement = this.$element.nativeElement;
    let tableRefs: NodeListOf<HTMLTableElement>;
    if (ele.tagName === 'NZ-TABLE') {
      tableRefs = ele.querySelectorAll('table');
    }
    return tableRefs;
  }

  /**
   * å¨headå½ååå å¥icon
   * @param idx å½ååçindex
   */
  insertIcon(idx: number) {
    // æåä¸ä¸ªä¸ç»æå¨
    if (idx === this.thListOfHead.length - 1) {
      return;
    }
    const iconWrap = document.createElement('div');
    iconWrap.classList.add('resize-indicator-wrap');
    const icon = document.createElement('i');
    icon.classList.add('resize-indicator', 'ag', 'ag-table-col-drag');
    iconWrap.appendChild(icon);

    // è¥å­å¨åä¸æ·»å 
    const iconWrapInstance = this.thListOfHead[idx].querySelector('.resize-indicator-wrap');
    if (iconWrapInstance) {
      this.thListOfHead[idx].removeChild(iconWrapInstance);
    }

    this.thListOfHead[idx].appendChild(iconWrap);

    this.addMouseDownListener(iconWrap, idx);
  }

  /**
   * æ·»å é¼ æ ç¹å»äºä»¶
   * é¼ æ å³é®ç¹å»ï¼æ·»å mouseMoveãmouseupäºä»¶ï¼æ¾å¼åç§»é¤mouseMoveãmouseupäºä»¶
   * mousedownEvt.button: 0 é¼ æ å·¦é® 1 é¼ æ ä¸­é® 2 é¼ æ å³é®
   * @param icon iconå®ä¾
   * @param idx å½ååçindex
   */
  addMouseDownListener(iconWrap: HTMLElement, idx: number) {
    this.removeMouseMoveAndUp();

    this.mousedown$ = fromEvent(iconWrap, 'mousedown').subscribe((mousedownEvt: MouseEvent) => {
      if (mousedownEvt.button !== 0) {
        return;
      }
      // å½åiconæå¨çåå¯¹åºçhead col
      const colOfHead: any = this.colListOfHead[idx];
      // å½åiconæå¨çåå¯¹åºçbody col
      const colOfBody: any = this.colListOfBody[idx];
      // å½åiconæå¨çåå¯¹åºçhead col åå§å®½åº¦
      const defaultWidth: number = colOfHead.clientWidth;

      this.addMouseMoveListener(colOfHead, colOfBody, defaultWidth, mousedownEvt);
      this.addMouseUpListener();
    });
  }

  /**
   * æ·»å é¼ æ ç§»å¨çå¬
   * @param colOfHead å½åiconæå¨çåå¯¹åºçhead col
   * @param colOfBody  å½åiconæå¨çåå¯¹åºçbody col
   * @param defaultWidth å½åiconæå¨çåå¯¹åºçhead col åå§å®½åº¦
   * @param mousedownEvt mouseDownäºä»¶åæ°
   */
  addMouseMoveListener(
    colOfHead: HTMLTableElement,
    colOfBody: HTMLTableElement,
    defaultWidth: number,
    mousedownEvt: MouseEvent
  ) {
    // TODO: æä¸ä½¿ç¨èæµï¼å ä¸ºèæµä½¿ç¨æ¶é´æ¶åçå»¶è¿
    this.mousemove$ = fromEvent(document, 'mousemove')
      .pipe(debounceTime(0))
      .subscribe((mousemoveEvt: MouseEvent) => {
        if (mousemoveEvt.button !== 0) {
          return;
        }
        const increment = mousemoveEvt.pageX - mousedownEvt.pageX;
        const full = increment + defaultWidth;

        // this.setIconWrapPosi(idx, increment);
        this.setData(colOfHead, colOfBody, full);
        // console.log('mousemove', mousemoveEvt);
      });
    this.mousemoveSubList.push(this.mousemove$);
  }

  /**
   * è®¾ç½®iconçä½ç½®
   * ææ¶å®ç°ä¸äºææ½iconä½ç½®æ¹åtdå®½åº¦ä¸åï¼å ä¸ºtdè®¾ç½®äºè¶åºéèï¼iconä½ç½®è¶åºtdä¼ä¸æ¾ç¤º
   * @param idx å½åæ¿æ´»çindex
   * @param increment  ææ½å¢å çå¤§å°
   */
  setIconWrapPosi(idx: number, increment: number) {
    const iconWrapInstance = this.thListOfHead[idx].querySelector('.resize-indicator-wrap');
    // console.log('iconWrapInstance', iconWrapInstance);
    const right = increment - 2;
    iconWrapInstance.setAttribute('right', `${right}px`);
  }

  /**
   * æ·»å é¼ æ æ¾å¼äºä»¶
   */
  addMouseUpListener() {
    this.mouseup$ = fromEvent(document, 'mouseup').subscribe((ele: any) => {
      // console.log('mouseup', this.mousemove$);
      setTimeout(() => {
        this.removeMouseMoveAndUp();
      });
    });
  }

  /**
   * ç§»é¤é¼ æ ç§»å¨åæ¾å¼çå¬äºä»¶
   */
  removeMouseMoveAndUp() {
    if (this.mouseup$) {
      this.mouseup$.unsubscribe();
    }
    this.mousemoveSubList.forEach((sub) => {
      if (sub) {
        sub.unsubscribe();
      }
    });
    this.mousemoveSubList = [];
  }

  /**
   * æ·»å é¼ æ ç§»å¨æ¶è®¾ç½®æ°æ®
   * @param colOfHead å½åiconæå¨çåå¯¹åºçhead col
   * @param colOfBody  å½åiconæå¨çåå¯¹åºçbody col
   * @param defaultWidth å½åiconæå¨çåå¯¹åºçhead col åå§å®½åº¦
   * @param mousedownEvt mouseDownäºä»¶åæ°
   * @param mousemoveEvt mousemoveäºä»¶åæ°
   * @param idx å½åindex
   */
  setData(colOfHead: HTMLTableElement, colOfBody: HTMLTableElement, full: number) {
    // console.log('full', full);
    if (full < Number(this.minResizeWidth)) {
      return;
    }
    colOfHead.style.width = full + 'px';
    colOfHead.style.minWidth = full + 'px';
    colOfBody.style.width = full + 'px';
    colOfBody.style.minWidth = full + 'px';
    this.setThFixedAttr();
  }

  /**
   * è®¾ç½®headãbodyçleftårightå¼
   */
  setThFixedAttr() {
    // console.log('setThFixedAttr', idx);
    let leftIncrement = 0; // å·¦è¾¹å¢å çå¼
    let rightIncrement = 0; // å³è¾¹å¢å çå¼
    const thCount = this.thListOfHead.length; // th æ°é
    // å¾ªç¯headå
    for (let i = 0; i < thCount; i++) {
      const rightI = thCount - 1 - i;
      let shouldSetStyle = false;

      // å½åhead th
      const thOfHeadLeft = this.thListOfHead[i];
      if (thOfHeadLeft.style.left) {
        thOfHeadLeft.style.left = leftIncrement + 'px';
        shouldSetStyle = true;
      }

      const thOfHeadRight = this.thListOfHead[rightI];
      if (thOfHeadRight.style.right) {
        thOfHeadRight.style.right = rightIncrement + 'px';
        shouldSetStyle = true;
      }
      if (shouldSetStyle) {
        // å¾ªç¯body tr
        for (const trOfBody of this.trListOfBody) {
          // è·å¾bodyå¯¹åºçtd
          const tdListOfBody = Array.from(trOfBody.cells) as HTMLTableHeaderCellElement[];

          const tdOfBodyLeft = tdListOfBody[i];
          if (tdOfBodyLeft.style.left) {
            tdOfBodyLeft.style.left = leftIncrement + 'px';
          }

          const tdOfBodyRight = tdListOfBody[rightI];
          if (tdOfBodyRight.style.right) {
            tdOfBodyRight.style.right = rightIncrement + 'px';
          }
        }
      }

      leftIncrement = leftIncrement + this.deletePx(this.colListOfHead[i].style.width);
      rightIncrement = rightIncrement + this.deletePx(this.colListOfHead[rightI].style.width);
    }
  }

  /**
   * å° `3px` è½¬ä¸ºæ°å­ 3
   * @param width å¸¦æpxçå®½åº¦
   */
  deletePx(width: string): number {
    return Number(width.replace('px', ''));
  }
}
